import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app.tsx';
import { initAnalytics } from './lib/analytics.ts';
import { queryClient } from './lib/query-client.ts';
import './styles/globals.css';

// Loads PostHog in an opted-out state (no-op without a key). Capture only
// begins once consent is synced from the user's profile — see AnalyticsConsentSync.
initAnalytics();

const root = document.getElementById('root');
if (!root) throw new Error('Root element missing');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
